import { createFileRoute } from "@tanstack/react-router"
import Advanced from "@/app/settings/metric/advanced/page"

export const Route = createFileRoute("/settings/metric/advanced")({
  component: Advanced,
})
